<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><strong>Abbreviations</strong></h1>
<h1 class="sec2a0" id="sec2-10">General</h1>
<table>
<tbody>
<tr>
<td class="td-abr1">
<p class="t-left-abr">§</p></td>
<td class="td-abr2">
<p class="t-left-abr">paragraph, section</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">BCE</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">Before the Common Era</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>c.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>circa</em>, about</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">CE</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">Common Era</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">cf.</p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>confer</em>, confer, compare</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ch.</p></td>
<td class="td-abr2">
<p class="t-left-abr">chapter</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">chs</p></td>
<td class="td-abr2">
<p class="t-left-abr">chapters</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">cp.</p></td>
<td class="td-abr2">
<p class="t-left-abr">compare</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ed.</p></td>
<td class="td-abr2">
<p class="t-left-abr">edited by</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">edn</p></td>
<td class="td-abr2">
<p class="t-left-abr">edition</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">esp.</p></td>
<td class="td-abr2">
<p class="t-left-abr">especially</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ET</p></td>
<td class="td-abr2">
<p class="t-left-abr">English translation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">etc.</p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>et cetera</em>, and so on</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">i.e.</p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>id est</em>, that is</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">intro.</p></td>
<td class="td-abr2">
<p class="t-left-abr">introduced by</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">LXX</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">Septuagint</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">n.</p></td>
<td class="td-abr2">
<p class="t-left-abr">note</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">no.</p></td>
<td class="td-abr2">
<p class="t-left-abr">number</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">NT</p></td>
<td class="td-abr2">
<p class="t-left-abr">New Testament</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">OT</p></td>
<td class="td-abr2">
<p class="t-left-abr">Old Testament</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">p(p).</p></td>
<td class="td-abr2">
<p class="t-left-abr">page(s)</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">repr.</p></td>
<td class="td-abr2">
<p class="t-left-abr">reprint edition</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">rev.</p></td>
<td class="td-abr2">
<p class="t-left-abr">revised; revised by</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>sic</em></p></td>
<td class="td-abr2">
<p class="t-left-abr">as it was written in the original</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">trans.</p></td>
<td class="td-abr2">
<p class="t-left-abr">translated by</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">v(v).</p></td>
<td class="td-abr2">
<p class="t-left-abr">verse(s)</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">vol.</p></td>
<td class="td-abr2">
<p class="t-left-abr">volume</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">vols</p></td>
<td class="td-abr2">
<p class="t-left-abr">volumes</p></td>
</tr>
</tbody>
</table>
<h1 class="sec2a0" id="sec2-11">Biblical and other ancient literature</h1>
<table>
<tbody>
<tr>
<td class="td-abr1">
<p class="t-left-abr">1 Cor.</p></td>
<td class="td-abr2">
<p class="t-left-abr">1 Corinthians</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">1 Macc.</p></td>
<td class="td-abr2">
<p class="t-left-abr">1 Maccabees</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">1QSa</p></td>
<td class="td-abr2">
<p class="t-left-abr">Rule of the Congregation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">1 Sam.</p></td>
<td class="td-abr2">
<p class="t-left-abr">1 Samuel</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Ambrose</p></td>
<td class="td-abr2">
<p class="t-left-abr"> </p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Virg.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>De virginibus</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Col.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Colossians</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Dan.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Daniel</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Deut.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Deuteronomy</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Eusebius</p></td>
<td class="td-abr2">
<p class="t-left-abr"> </p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Hist. eccl.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Historia ecclesiastica</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Exod.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Exodus</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Gal.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Galatians</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Gen.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Genesis</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Heb.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Hebrews</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Hos.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Hosea</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Irenaeus</p></td>
<td class="td-abr2">
<p class="t-left-abr"> </p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Adv. haer.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Adversus haereses</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Isa.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Isaiah</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Jer.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Jeremiah</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Josephus</p></td>
<td class="td-abr2">
<p class="t-left-abr"> </p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Ag. Ap.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Against Apion</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Ant.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Jewish Antiquities</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>J.W.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Jewish War</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Josh.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Joshua</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Judg.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Judges</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Lev.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Leviticus</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Mal.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Malachi</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Matt.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Matthew</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Mic.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Micah</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Num.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Numbers</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Origen</p></td>
<td class="td-abr2">
<p class="t-left-abr"> </p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Hom. Luc.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Homiliae in Lucam</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Philo</p></td>
<td class="td-abr2">
<p class="t-left-abr"> </p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr1"><em>Dec.</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>On the Decalogue</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Prov.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Proverbs</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Ps(s).</p></td>
<td class="td-abr2">
<p class="t-left-abr">Psalm(s)</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Rev.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Revelation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Rom.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Romans</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Sir.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Sirach</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Wisd.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Wisdom</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Zech.</p></td>
<td class="td-abr2">
<p class="t-left-abr">Zechariah</p></td>
</tr>
</tbody>
</table>
<h1 class="sec2a0" id="sec2-12">Modern literature</h1>
<table>
<tbody>
<tr>
<td class="td-abr1">
<p class="t-left-abr">AB</p></td>
<td class="td-abr2">
<p class="t-left-abr">Anchor Bible</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>ABR</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Australian Biblical Review</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ABRL</p></td>
<td class="td-abr2">
<p class="t-left-abr">Anchor Bible Reference Library</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ACCNT</p></td>
<td class="td-abr2">
<p class="t-left-abr">Ancient Christian Commentary on Scripture, New Testament</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ACW</p></td>
<td class="td-abr2">
<p class="t-left-abr">Ancient Christian Writers</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>ANF</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>The Ante-Nicene Fathers</em>. Ed. Alexander Roberts and James Donaldson, 1885–7. 10 vols. Repr. Peabody, MA: Hendrickson, 1994.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">AS</p></td>
<td class="td-abr2">
<p class="t-left-abr">Advances in Semiotics</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">AV</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">Authorized Version (also known as the King James Version)</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">BETL</p></td>
<td class="td-abr2">
<p class="t-left-abr">Bibliotheca ephemeridum theologicarum lovaniensium</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">BibInt</p></td>
<td class="td-abr2">
<p class="t-left-abr">Biblical Interpretation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">BZNW</p></td>
<td class="td-abr2">
<p class="t-left-abr">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>CBQ</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">CEB</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">Common English Bible</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">CSEL</p></td>
<td class="td-abr2">
<p class="t-left-abr">Corpus scriptorum ecclesiasticorum latinorum</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">CSS</p></td>
<td class="td-abr2">
<p class="t-left-abr">Cistercian Studies Series</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>CurBR</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Currents in Biblical Research</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>DJG</em><sup>2</sup></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Dictionary of Jesus and the Gospels</em>. Ed. Joel B. Green. 2nd edn. Downers Grove, IL: IVP Academic, 2013.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>DMBI</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Dictionary of Major Biblical Interpreters</em>. Ed. Donald K. McKim. 2nd edn. Downers Grove, IL: IVP Academic, 2007.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">FC</p></td>
<td class="td-abr2">
<p class="t-left-abr">The Fathers of the Church</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">ICC</p></td>
<td class="td-abr2">
<p class="t-left-abr">International Critical Commentary</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">Int</p></td>
<td class="td-abr2">
<p class="t-left-abr">Interpretation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>Int</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>JBL</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>JECS</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Journal of Early Christian Studies</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">JPTSup</p></td>
<td class="td-abr2">
<p class="t-left-abr">Journal of Pentecostal Theology Supplement Series</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>JRS</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Journal of Roman Studies</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>JSNT</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>JTI</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Journal of Theological Interpretation</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>JTS</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">LNTS</p></td>
<td class="td-abr2">
<p class="t-left-abr">Library of New Testament Studies</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>LTQ</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Lexington Theological Quarterly</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">NAB</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">New American Bible (2011)</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">NET</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">New English Translation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">NETS</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">New English Translation of the Septuagint</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">NICNT</p></td>
<td class="td-abr2">
<p class="t-left-abr">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>NIDB</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>New Interpreter’s Dictionary of the Bible</em>. Ed. Katharine Doob Sakenfeld. 5 vols. Nashville, TN: Abingdon, 2006–9.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">NMBI</p></td>
<td class="td-abr2">
<p class="t-left-abr">New Methods in Biblical Interpretation</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>NovT</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">NovTSup</p></td>
<td class="td-abr2">
<p class="t-left-abr">Supplements to Novum Testamentum</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>NPNF</em><sup>2</sup></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Nicene and Post-Nicene Fathers</em>, second series</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><span class="smallcaps">NRSV</span></p></td>
<td class="td-abr2">
<p class="t-left-abr">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>NRTh</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>La nouvelle revue théologique</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">NTT</p></td>
<td class="td-abr2">
<p class="t-left-abr">New Testament Theology</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">OECS</p></td>
<td class="td-abr2">
<p class="t-left-abr">Oxford Early Christian Studies</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>OGIS</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Orientis Graeci Inscriptiones Selectae</em>. Ed. Wilhelm Dittenberger. 2 vols. Leipzig: Hirzel, 1903–5.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">OSHT</p></td>
<td class="td-abr2">
<p class="t-left-abr">Oxford Studies in Historical Theology</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">OWC</p></td>
<td class="td-abr2">
<p class="t-left-abr">Oxford World’s Classics</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>ProEccl</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Pro ecclesia</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>RevExp</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Review &amp; Expositor</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">RThN</p></td>
<td class="td-abr2">
<p class="t-left-abr">Religion, Theologie und Naturwissenschaft</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">SBLSBL</p></td>
<td class="td-abr2">
<p class="t-left-abr">Society of Biblical Literature Studies in Biblical Literature</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>SCE</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Studies in Christian Ethics</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">SHS</p></td>
<td class="td-abr2">
<p class="t-left-abr">Scripture and Hermeneutics Series</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>SJT</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">SNTSMS</p></td>
<td class="td-abr2">
<p class="t-left-abr">Society of New Testament Studies Monograph Series</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>TD</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Theology Digest</em></p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>TDNT</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Theological Dictionary of the New Testament</em>. Ed. Gerhard Kittel and Gerhard Friedrich. Trans. Geoffrey W. Bromiley. 10 vols. Grand Rapids, MI: Eerdmans, 1964–76.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">THNTC</p></td>
<td class="td-abr2">
<p class="t-left-abr">Two Horizons New Testament Commentary</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr"><em>TLNT</em></p></td>
<td class="td-abr2">
<p class="t-left-abr"><em>Theological Lexicon of the New Testament</em>. Ceslas Spicq. Trans. and ed. James D. Ernest. 3 vols. Peabody, MA: Hendrickson, 1994.</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">TSc</p></td>
<td class="td-abr2">
<p class="t-left-abr">Theology and the Sciences</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">VTSup</p></td>
<td class="td-abr2">
<p class="t-left-abr">Supplements to Vetus Testamentum</p></td>
</tr>
<tr>
<td class="td-abr1">
<p class="t-left-abr">WUNT</p></td>
<td class="td-abr2">
<p class="t-left-abr">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?197ca54f